import { render, staticRenderFns } from "./CvPreviewWrapper.vue?vue&type=template&id=da7ab6fa&scoped=true&"
import script from "./CvPreviewWrapper.vue?vue&type=script&lang=ts&"
export * from "./CvPreviewWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./CvPreviewWrapper.vue?vue&type=style&index=0&id=da7ab6fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7ab6fa",
  null
  
)

export default component.exports